import { useEffect } from 'react'
import { useAuthStore } from '../store/auth-store'
import { useSession } from '../hooks/use-session'

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const setUser = useAuthStore((state) => state.setUser)
  const { session, loading } = useSession()

  useEffect(() => {
    if (session) {
      setUser(session.user)
    } else if (!loading) {
      setUser(null)
    }
  }, [session, loading])

  // Opcional: Mostrar um loading enquanto verifica a sessão
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-32 w-32 animate-pulse rounded-lg bg-accent/10" />
      </div>
    )
  }

  return children
} 